import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import { routes } from '../../routes/AppRoutes';
import { strings } from '../../resources/strings';
import { useAuth } from '../../contexts/AuthContext';
import { ProfileType } from '../../enums/ProfileType';
import { Body } from '../../common-components/Layout/Body/Body';
import { Header } from '../../common-components/Layout/Header/Header';
import { Page } from '../../common-components/Layout/Page/Page';
import { IBreadcrumbItem } from '../../common-components/Breadcrumb/Breadcrumb';
import { Button } from '../../common-components/Button/Button';
import { If } from '../../common-components/If/If';
import { ModalGroupedGeneralOrderReport } from '../../components/ModalGroupedGeneralOrderReport/ModalGroupedGeneralOrderReport';
import { ModalTransportOrderBaseReport } from '../../components/ModalTransportOrderBaseReport/ModalTransportOrderBaseReport';
import { ModalTransferredItemsSeparationListReport } from '../../components/ModalTransferredItemsSeparationListReport/ModalTransferredItemsSeparationListReport';
import { ModalMetabase } from '../../components/ModalMetabase/ModalMetabase';

const Reports: React.FC = () => {

  const navigate = useNavigate();
  const { session, signOut } = useAuth();

  const [modalGroupedGeneralOrderReportFilterVisible, setModalGroupedGeneralOrderReportFilterVisible] = React.useState<boolean>(false);
  const [modalTransportOrderBaseReportFilterVisible, setModalTransportOrderBaseReportFilterVisible] = React.useState<boolean>(false);
  const [modalTransferredItemsSeparationListReportFilterVisible, setModalTransferredItemsSeparationListReportFilterVisible] = React.useState<boolean>(false);
  const [modalMetabaseSource, setModalMetabaseSource] = React.useState<string>('');

  const breadcrumbItems: IBreadcrumbItem[] = React.useMemo(() => {
    const memo: IBreadcrumbItem[] = [
      {
        text: strings.Home,
        route: routes.Home
      }
    ];
    return memo;
  }, []);

  useEffect(() => {
    if (!session) {
      signOut(() => {
        navigate(routes.Login);
      });
      return;
    }
  }, [session, navigate]);

  const headerRender = (
    <Header title={strings.GeneralReports} breadcrumbItems={breadcrumbItems} alertSummary={false} />
  );

  return (
    <Page header={headerRender}>
      <Body marginTop='5px'>

        <Card>
          <Card.Body>
            <Card.Title>{strings.GroupedGeneralReport}</Card.Title>
            <Card.Text>
              {strings.TextAboutTheGroupedGeneralReport}
            </Card.Text>
            <Button colorIcon='primary' text={strings.ExportReport} click={() => setModalGroupedGeneralOrderReportFilterVisible(true)} />
          </Card.Body>
        </Card>

        <If condition={session?.user?.profileType !== ProfileType.Vendor}>
          <Card>
            <Card.Body>
              <Card.Title>{strings.TransportOrderBaseReport}</Card.Title>
              <Card.Text>
                {strings.TextAboutTheTransportOrderBaseReport}
              </Card.Text>
              <Button colorIcon='primary' text={strings.ExportReport} click={() => setModalTransportOrderBaseReportFilterVisible(true)} />
            </Card.Body>
          </Card>
        </If>

        <Card>
          <Card.Body>
            <Card.Title>{strings.TransferredItemsSeparationListReport}</Card.Title>
            <Card.Text>
              {strings.TextAboutTheTransferredItemsSeparationListReport}
            </Card.Text>
            <Button colorIcon='primary' text={strings.ExportReport} click={() => setModalTransferredItemsSeparationListReportFilterVisible(true)} />
          </Card.Body>
        </Card>

        <If condition={session?.user?.profileType == ProfileType.Admin || session?.user?.profileType == ProfileType.Ecommerce}>
          <Card>
            <Card.Body style={{ paddingBottom: '0px' }}>
              <Card.Title>Relatórios Metabase</Card.Title>
              <Card.Text>
                Clique em um dos links abaixo para acessar o relatório desejado.
              </Card.Text>
            </Card.Body>
            <ListGroup variant="flush" style={{ borderTop: 'none' }}>
              <ListGroup.Item>
                <Card.Link style={{ cursor: 'pointer' }}
                  onClick={() => setModalMetabaseSource('https://metabase.zerezes.com.br/public/question/2119c83c-8cc4-46be-a892-e1324d04c9b0')}
                >E-Commerce - Status consolidado de pacote transportado</Card.Link>
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </If>

      </Body>
      <If condition={modalGroupedGeneralOrderReportFilterVisible}>
        <ModalGroupedGeneralOrderReport
          close={() => setModalGroupedGeneralOrderReportFilterVisible(false)}
        />
      </If>
      <If condition={modalTransportOrderBaseReportFilterVisible}>
        <ModalTransportOrderBaseReport
          close={() => setModalTransportOrderBaseReportFilterVisible(false)}
        />
      </If>
      <If condition={modalTransferredItemsSeparationListReportFilterVisible}>
        <ModalTransferredItemsSeparationListReport
          close={() => setModalTransferredItemsSeparationListReportFilterVisible(false)}
        />
      </If>
      <If condition={modalMetabaseSource != ''}>
        <ModalMetabase
          title='Relatórios Metabase'
          visible={true}
          source={modalMetabaseSource}
          close={() => setModalMetabaseSource('')}
        />
      </If>
    </Page>
  );
}

export default Reports;